var map = {
	"./en/age-gate.json": 1663,
	"./en/common.json": 7201,
	"./en/images.json": 580,
	"./en/language-switcher.json": 8723,
	"./en/pages/coming-soon.json": 4372,
	"./en/pages/error.json": 1097,
	"./en/pages/illegal.json": 5433,
	"./en/pages/not-found.json": 3481,
	"./en/theme-switcher.json": 2651,
	"./nl/age-gate.json": 4990,
	"./nl/common.json": 1145,
	"./nl/images.json": 3988,
	"./nl/language-switcher.json": 7176,
	"./nl/pages/coming-soon.json": 4597,
	"./nl/pages/error.json": 5144,
	"./nl/pages/illegal.json": 8503,
	"./nl/pages/not-found.json": 3431,
	"./nl/theme-switcher.json": 3982,
	"./package.json": 1194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7831;